export const profilePageEn = {
  downloadDesktop: 'Desktop App',
  downloadForYourOS: 'Download for your OS',
  otherOS: 'For other OS',
  mobileApps: 'Mobile apps',
  uploadCustomBg: 'Upload custom',
  theme: 'Color scheme',
  darkTheme: 'Dark',
  lightTheme: 'Light',
  emailNotificationSettings: 'Email notification settings',
  notifications: 'Notifications',
  systemAppearance: 'System appearance',
  chooseColorScheme: 'Choose a color scheme',
  turnOnColumnColor: 'Turn on column color',
  themeVariation: 'Left and top panel',
  themeVariationNone: 'Monochrome gray',
  themeVariationAuto: 'Transparent adaptive',
  themeVariationLighter: 'Transparent light',
  themeVariationDarker: 'Transparent dark',
  themeVariationTransparent: 'Transparent',
  interfaceLanguage: 'Interface language',
  chooseBackground: 'Choose the background of the boards',
  uploadPhoto: 'Upload a photo',
  deletePhoto: 'Delete photo',
  deletePhotoConfirm: 'Delete profile photo?',
  passwordChange: 'Password change',
  passwordChangeAware:
    'To protect your account, make sure your new password is:',
  passwordChangeSentence1: 'Contains 8 or more characters',
  passwordChangeSentence1_1: '(necessarily)',
  passwordChangeSentence2:
    'Does not match your name or anything associated with you',
  passwordChangeSentence3: "Doesn't match any of",
  passwordChangeSentence4: 'the most commonly used passwords list',
  currentPassword: 'Current password',
  newPassword: 'New password',
  newPasswordAgain: 'New password again',
  newPasswordTooShort:
    'The new password is too short, you need at least 8 characters',
  newPasswordNotMatch:
    'Re-entering the new password does not match the new password',
  changeEmail: 'Change e-mail',
  emailChange: 'E-mail change',
  emailChangeYourCurrentEmail: 'Your current email:',
  emailChangeEnterNewEmail: 'Enter new email:',
  emailChangeEnterCurrentPassword: 'Enter current password:',
  emailChangeEmailPlaceholder: 'Email...',
  emailChangePasswordPlaceholder: 'Password',
  emailChangeAfterSentence1: 'Check your new email, we wrote you there',
  emailChangeAfterSentence2:
    'Follow the link in the email to confirm the email change.',
  emailChangeSuccess: 'You have successfully changed your email',
  emailChangeFail: 'Failed to change email',
  unsplashPlaceholder: 'Search through a million pictures on Unsplash',
  buttonSearch: 'Search',
  tasks: 'By tasks',
  chats: 'Through personal and group chats',
  event: 'Event',
  soundNotification: 'Sound Notification',
  browserNotification: 'Browser Notification',
  chatNotification: 'Chat Notification',
  mobileNotification: 'Push in mobile',
  selfAssignment: 'Appointing you as an executor',
  otherAssignment: 'Appointing another user as executor',
  taskCompleted: 'Completion of a task',
  taskMoved: 'Task moved to another column/board',
  deadlineNotification: 'Missing a deadline',
  newChatMessage: 'Task chat message',
  mentionChatMessage: 'Mention via @ in task chat',
  groupChatMessage: 'Group chat message',
  mentionInGroupChat: 'Mention via @ in group chat',
  messageInChat: 'Message in personal chat'
}

export const profilePageRu: typeof profilePageEn = {
  downloadDesktop: 'Десктопное приложение',
  downloadForYourOS: 'Скачать для вашей ОС',
  otherOS: 'Для других ОС',
  mobileApps: 'Мобильные приложения',
  uploadCustomBg: 'Загрузить свой',
  theme: 'Стиль интерфейса',
  darkTheme: 'Тёмный',
  lightTheme: 'Светлый',
  emailNotificationSettings: 'Настройки e-mail оповещений',
  notifications: 'Уведомления',
  systemAppearance: 'Внешний вид системы',
  chooseColorScheme: 'Выберите цветовую схему',
  turnOnColumnColor: 'Включить цвет у колонок',
  themeVariation: 'Левая и верхняя панель',
  themeVariationNone: 'Монохромная серая',
  themeVariationAuto: 'Полупрозрачная адаптивная',
  themeVariationLighter: 'Полупрозрачная светлая',
  themeVariationDarker: 'Полупрозрачная тёмная',
  themeVariationTransparent: 'Полупрозрачная',
  interfaceLanguage: 'Язык интерфейса',
  chooseBackground: 'Выберите фон досок',
  uploadPhoto: 'Загрузить фото',
  deletePhoto: 'Удалить фото',
  deletePhotoConfirm: 'Удалить фото профиля?',
  passwordChange: 'Смена пароля',
  passwordChangeAware:
    'Для защиты своего аккаунта убедитесь, что ваш новый пароль:',
  passwordChangeSentence1: 'Содержит 8 и более символов',
  passwordChangeSentence1_1: '(обязательно)',
  passwordChangeSentence2:
    'Не совпадает с вашим именем или чем-то ассоциируемым с вами',
  passwordChangeSentence3: 'Не совпадает с любым из',
  passwordChangeSentence4: 'списка самых часто используемых паролей',
  currentPassword: 'Текущий пароль',
  newPassword: 'Новый пароль',
  newPasswordAgain: 'Новый пароль ещё раз',
  newPasswordTooShort:
    'Новый пароль слишком короткий, нужно минимум 8 символов',
  newPasswordNotMatch:
    'Повторный ввод нового пароля не совпадает с новым паролем',
  changeEmail: 'Сменить e-mail',
  emailChange: 'Смена e-mail',
  emailChangeYourCurrentEmail: 'Ваш текущий e-mail:',
  emailChangeEnterNewEmail: 'Введите новый e-mail:',
  emailChangeEnterCurrentPassword: 'Введите текущий пароль:',
  emailChangeEmailPlaceholder: 'E-mail...',
  emailChangePasswordPlaceholder: 'Пароль',
  emailChangeAfterSentence1: 'Проверьте указанную почту, мы написали вам туда',
  emailChangeAfterSentence2:
    'Перейдите по ссылке в письме для подтверждения смены почты.',
  emailChangeSuccess: 'Вы успешно сменили почту',
  emailChangeFail: 'Не удалось изменить почту',
  unsplashPlaceholder: 'Поиск среди миллиона картинок на Unsplash',
  buttonSearch: 'Найти',
  tasks: 'По задачам',
  chats: 'По личным и групповым чатам',
  event: 'Событие',
  soundNotification: 'Звуковое уведомление',
  browserNotification: 'Уведомление в браузере',
  chatNotification: 'Индикация в чатах',
  mobileNotification: 'Push в мобильном',
  selfAssignment: 'Назначение вас исполнителем',
  otherAssignment: 'Назначение исполнителем другого пользователя',
  taskCompleted: 'Выполнение задачи',
  taskMoved: 'Перемещение задачи в другую колонку/доску',
  deadlineNotification: 'Пропуск дедлайна', // NB! change behaviour
  newChatMessage: 'Сообщение в чате задачи',
  mentionChatMessage: 'Упоминание через @ в чате задачи',
  groupChatMessage: 'Сообщение в групповом чате',
  mentionInGroupChat: 'Упоминание через @ в групповом чате',
  messageInChat: 'Сообщение в личном чате'
}
